import View from './View.js';
import { URL, MODAL_CLOSE_SEC, TIMEOUT_SEC } from '../config.js';
// import {  } from '../config.js';
import logo from 'url:../../../src/img/logo.png';

class ResetPasswordView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Reset Password Error Message';
  _message = 'Reset Password Success Message';

  addHandlerNewPassword(handler) {
    let save;
    this._parentElement.addEventListener('click', function (e) {
      save = e.target.closest('.btn--new-pass');
      if (!save) return;

      const formReset = document.querySelector('.user-cred__form--reset');
      formReset.addEventListener('submit', function (e) {
        e.preventDefault();
        save.disabled = true;
        save.textContent = 'Saving...'; // Update text for feedback
        const dataArr = [...new FormData(this)];
        const data = Object.fromEntries(dataArr);

        handler(data);
        setTimeout(() => {
          save.disabled = false;
          save.textContent = 'Reset Password'; // Update text for feedback
        }, MODAL_CLOSE_SEC * 1000);
      });
    });
  }

  _generateMarkup() {
    return `
      <div class="row user-cred">
        <div class="user-cred__head">
          <h1 class="user-cred__heading">Reset Password</h1>
        </div>
        <div class="user-cred__container">
          <div class="user-cred__logo">
            <div class="user-cred__logo--img">
              <img src="${logo}" alt="Pragya Enterprises Logo" />
            </div>
            <h3 class="user-cred__title"></h3>
            <p class="paragraph user-cred__description">
              For every student, every classroom.<br />
              Real uniforms.
            </p>
          </div>
          <div class="user-cred__form--container">
            <form
              action="#"
              class="user-cred__form user-cred__form--reset"
              name="userCredForm"
              autocomplete="off"
            >
              <!-- PASSWORD -->
              <div class="user-cred__email label-input">
                <label for="password">New Password</label>
                <input
                  type="password"
                  placeholder="enter new password"
                  name="password"
                  id="password"
                  required
                />
              </div>

              <!-- PASSWORD CONFIRM -->
              <div class="user-cred__email label-input">
                <label for="password-confirm">Confirm Password </label>
                <input
                  type="password"
                  placeholder="enter new confirm password"
                  name="passwordConfirm"
                  id="password-confirm"
                  required
                />
              </div>
              <div class="user-cred__terms">
                <input
                  type="checkbox"
                  id="terms"
                  class="user-cred__terms--check"
                  required
                />
                <label class="user-cred__terms--label" for="terms"
                  >I agree with <a href="/terms" style="text-decoration: none; color: #0066fb" target="_blank"> Terms & Conditions.</a></label
                >
              </div>
              <div class="user-cred__btn--container">
                <button type="submit" class="btn btn--new-pass">Save new password</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    `;
  }
}

export default new ResetPasswordView();
